import React from 'react';
import Hero from './Hero';
import WhatWeDo from './WhatWeDo';
import HowItAllStarted from './HowItAllStarted';
import WhatWeWorking from './WhatWeWorking';
import BackedBy from './BackedBy';
import BeAPart from './BeAPart';
import CompanyFounders from './CompanyFounders';

const AboutUs = ({ data }): any => (
  <>
    <Hero data={data?.HeroData} />

    <WhatWeDo data={data?.WhatWeDo} />

    <CompanyFounders data={data?.companyFounders} />

    <HowItAllStarted data={data?.HowItAllStarted} />

    <WhatWeWorking data={data?.WhatWeWorking} />

    <BackedBy data={data?.backedBy} />

    <BeAPart data={data?.BeAPart} />
  </>
);

export default AboutUs;
